module.exports = __webpack_public_path__ + "img/syn_distortions.729bbdae.png";